import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

export type ErrorBoxProps = {
	error: string
	type?: string
	children?: ReactNode
}

export function ErrorBox({ error, children, type = 'UNKNOWN' }: ErrorBoxProps) {
	const { t } = useTranslation('common')

	const content = children ?? (
		<>
			{t('errorBox.defaultMessage')}{' '}
			<span className="font-bold underline text-red-600 decoration-red-200 decoration-2">
				{t('errorBox.contactRep')}
			</span>.
		</>
	)

	return (
		<div>
			<div className="ring ring-red-200 p-4 rounded-md">
				<div className="text-red-600 text-2xl">{t('errorBox.title')}</div>
				<div className="mt-2 text-sm text-grey-700">
					{content}
				</div>
				<div className="mt-4">
					<span className="font-mono text-xs text-brand-500 uppercase">{type}::</span>
					<span className="font-mono text-xs text-brand-500 uppercase">{error}</span>
				</div>
			</div>
		</div>
	)
}
